export default [
	{
		title: 'Dashboard',
		path: '/',
		id: 'menu_1',
		sidebarIcon: <i className='fa fa-th-large' aria-hidden='true'></i>,
		permission: 'view-dashboard',
	},
	{
		sidebarIcon: (
			<i className='material-icons-round fa fa-th-large' aria-hidden='true'></i>
		),
		title: `Dashboard`,
		path: '/portfolio/dashboard',
		id: 'menu_8',
		permission: 'view-colender-dashboard',
	},
	
	{
		title: 'Manage Lead',
		path: '/manage-leads',
		id: 'menu_2',
		sidebarIcon: <i className='fa fa-user-plus' aria-hidden='true'></i>,
		subChilds: [
			{
				title: 'Manage Lead',
				path: '/manage-leads',
				icon: <i className='fa fa-hand-pointer-o' aria-hidden='true'></i>,
				permission: 'lead-listing',
			},
			{
				icon: <i className='fa fa-plus-circle' aria-hidden='true'></i>,
				title: 'Add Lead',
				path: '/lead/add',
				permission: 'add-lead',
			},
		],
		permission: 'manage-lead',
	},
	{
		title: 'Manage Applications',
		path: '/manage-applications',
		id: 'menu_2',
		sidebarIcon: <i className='fa fa-user-plus' aria-hidden='true'></i>,
		permission: 'manage-dsa-lead',
		// subChilds: [
		// 	{
		// 		title: 'Manage Leads',
		// 		path: '/manage-leads',
		// 		icon: <i className='fa fa-hand-pointer-o' aria-hidden='true'></i>
		// 	},

		// ]
	},
	{
		path: '/affiliate/manage-users',
		title: 'Manage ACL',
		id: 'menu_3',
		sidebarIcon: <i className='fa fa-file-image-o' aria-hidden='true'></i>,
		permission: 'manage-acl',
		
	},
	{
		path: '/comission-report',
		title: 'Affiliate Commission Reports',
		id: 'menu_3',
		sidebarIcon: <i className='fa fa-file-image-o' aria-hidden='true'></i>,
		permission: 'generate-partner-commission',
	},
	{
		path: '/dsa/comission-report',
		title: 'DSA Commission Reports',
		id: 'menu_3',
		sidebarIcon: <i className='fa fa-file-image-o' aria-hidden='true'></i>,
		permission: 'generate-dsa-commission',
	},
	{
		title: 'Manage ACL',
		sidebarIcon: <i className='fa fa-file-image-o' aria-hidden='true'></i>,
		permission: 'manage-lender-acl',
		path: '/lender/manage-users',
		id: 'menu_23',
		subChilds: [
			{
				path: '/lender/roles',
				title: 'Manage Role',
				icon: (
					<i
						className='item-icon material-icons-round fa fa-hand-pointer-o mt-1'
						aria-hidden='true'
					></i>
				),
			},
			{
				path: '/lender/role/add',
				title: 'Add Role',
				icon: (
					<i
						className='item-icon material-icons-round fa fa-plus-circle mt-1'
						aria-hidden='true'
					></i>
				),
			},
			{
				path: '/lender/manage-users',
				title: 'Manage User',
				icon: (
					<i
						className='item-icon material-icons-round fa fa-hand-pointer-o mt-1'
						aria-hidden='true'
					></i>
				),
			},
			{
				path: '/lender/manage-users/add',
				title: 'Add User',
				icon: (
					<i
						className='item-icon material-icons-round fa fa-plus-circle mt-1'
						aria-hidden='true'
					></i>
				),
			},
		],
	},
	{
		path: '/portfolio/assigned',
		title: 'Lender Portal',
		id: 'menu_4',
		sidebarIcon: <i className='fa fa-cog' aria-hidden='true'></i>,
		permission: 'lender-portal',
		subChilds: [
			{
				icon: <i className='fa fa-shopping-bag' aria-hidden='true'></i>,
				title: `Assigned Portfolio`,
				path: '/portfolio/assigned',
				permission: 'assigned-portfolio',
			},

			{
				icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
				title: 'Sanction Portfolio',
				path: '/portfolio/approved',
				permission: 'sanction-portfolio',
			},
			{
				icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
				title: 'Sanction Rejected',
				path: '/portfolio/sanction-rejected',
				permission: 'sanction-rejected',
			},
			{
				icon: <i className='fa fa-tags' aria-hidden='true'></i>,
				title: 'Disbursal Pending',
				path: '/portfolio/disbursal-pending',
				permission: 'disbursal-pending',
			},
			{
				icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
				title: 'Disbursed Portfolio',
				path: '/portfolio/disbursal-approved',
				permission: 'disbursed-portfolio',
			},
			{
				icon: <i className='fa fa-file-text-o' aria-hidden='true'></i>,
				title: 'Disbursed Rejected',
				path: '/portfolio/disbursal-rejected',
				permission: 'disbursed-rejected',
			},
		],
	},
	{
		path: '/onboarding/details/partner',
		permission: 'dsa-onboarding-form',
		title: 'Onboarding Form',
		id: 'menu_5',
		sidebarIcon: (
			<i
				className='item-icon material-icons-round fa fa-cog mt-1'
				aria-hidden='true'
			></i>
		),
	},
	{
		path: '/affiliate/kyc',
		title: 'Settings',
		id: 'menu_41',
		sidebarIcon: <i className='fa fa-cog' aria-hidden='true'></i>,
		subChilds: [
			{
				title: 'Profile',
				path: '/affiliate/kyc',
				icon: <i className='fa fa-hand-pointer-o' aria-hidden='true'></i>,
			},
			{
				title: 'Api Details',
				path: '/affiliate/api-details',
				icon: <i className='fa fa-hand-pointer-o' aria-hidden='true'></i>,
			},
		],
		permission: 'edit-kyc',
	},
];
